import * as React from "react";
import { SVGProps } from "../types";

const ShopifyIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#595961"
      fillRule="evenodd"
      d="M13.189 11.64h-.059a.525.525 0 0 1-.449-.512c-.014-.24-.145-5.867 3.029-7.146.797-.316 1.537-.256 2.16.21.767.557 1.318 1.67 1.652 3.295.231 1.144.275 2.136.275 2.182.014.24-.173.42-.42.376a.52.52 0 0 1-.45-.497c-.043-1.023-.377-3.836-1.477-4.648-.348-.256-.784-.286-1.305-.076-2.725 1.099-2.594 6.38-2.594 6.44 0 .21-.145.375-.362.375"
      clipRule="evenodd"
    ></path>
    <path
      fill="#B2B2C2"
      fillRule="evenodd"
      d="M17.71 4.223c-.58-.422-1.26-.482-2-.196-1.29.527-2.203 1.91-2.652 4.017-.333 1.55-.29 2.948-.29 3.009 0 .075.03.15.087.21.058.06.116.106.188.106h.044c.13 0 .232-.106.232-.241 0-.06-.13-5.431 2.667-6.56.565-.225 1.057-.195 1.464.106 1.173.857 1.521 3.761 1.565 4.799 0 .15.13.3.29.316a.232.232 0 0 0 .26-.24c-.014-.181-.174-4.093-1.855-5.326"
      clipRule="evenodd"
      opacity="0.46"
    ></path>
    <path
      fill="#B2B2C2"
      fillRule="evenodd"
      d="M13.058 11.188h-.028c-.088-.015-.16-.105-.175-.196 0-.06-.043-1.429.29-2.978.434-2.061 1.348-3.43 2.608-3.942.71-.286 1.349-.225 1.9.166 1.623 1.188 1.782 5.04 1.782 5.205 0 .09-.072.15-.16.135-.086-.015-.159-.09-.174-.195 0-.045-.159-3.821-1.623-4.905-.435-.315-.97-.36-1.58-.12-2.84 1.189-2.71 6.634-2.71 6.695.015.075-.043.135-.13.135"
      clipRule="evenodd"
      opacity="0.46"
    ></path>
    <path
      fill="#595961"
      fillRule="evenodd"
      d="M14.232 6.886c.116-.226.232-.452.334-.692-.044.075-.334.857-1.218.737-.015 0 .521.165.884-.045M13.912 7.848c.087-.24.174-.496.233-.737-.029.09-.174.903-1.102.903 0 0 .536.105.87-.166M19 5.908c-.117-.271-.247-.527-.378-.798.044.09.479.948-.014 1.565 0 0 .377-.3.391-.767M18.203 4.554a11 11 0 0 0-.696-.542c.087.075.855.632.812 1.475-.015 0 .116-.497-.116-.933M14.652 6.058c.174-.18.319-.376.478-.587-.058.06-.536.677-1.39.451 0 0 .492.271.912.136M15.188 5.366c.203-.15.391-.3.58-.466-.072.045-.667.541-1.493.18 0 0 .478.346.913.286M15.97 4.87a10 10 0 0 0 .71-.256c-.086.03-.825.3-1.55-.271.015 0 .392.451.84.526M16.68 4.599c.204.03.406.045.609.06-.072-.015-.71-.06-1.072-.662 0 0 .145.406.464.602M17.522 4.93c.144.165.304.33.478.48-.058-.06-.55-.556-.435-1.172-.015 0-.174.346-.043.691"
      clipRule="evenodd"
      opacity="0.62"
    ></path>
    <path
      fill="url(#paint0_linear_1334_1871)"
      fillRule="evenodd"
      d="M19.276 9.368c0-.166-.16-3.972-1.74-5.13a1.63 1.63 0 0 0-.985-.331q-.391 0-.826.18c-1.261.497-2.146 1.836-2.58 3.882-.333 1.534-.29 2.903-.29 2.963 0 .045.044.09.087.09h.014c.044 0 .074-.03.074-.075 0-.06-.146-5.55 2.767-6.724q.957-.383 1.653.135c1.506 1.098 1.666 4.935 1.666 4.98s.044.09.087.09h.014c.03.015.059-.015.059-.06"
      clipRule="evenodd"
      opacity="0.74"
    ></path>
    <path
      fill="url(#paint1_linear_1334_1871)"
      fillRule="evenodd"
      d="M19.522 7.487Q19.02 5.05 17.87 4.193a2.06 2.06 0 0 0-1.363-.406q.586.045 1.087.406c.768.556 1.32 1.67 1.653 3.294.231 1.144.274 2.137.274 2.182 0 .18-.087.316-.232.36.03.016.058.016.073.016.247.03.435-.136.42-.376.015-.045-.029-1.023-.26-2.182"
      clipRule="evenodd"
    ></path>
    <path
      fill="url(#paint2_linear_1334_1871)"
      fillRule="evenodd"
      d="M15.87 4.825c-2.725 1.098-2.595 6.378-2.595 6.438 0 .18-.087.316-.232.361.03.015.043.015.073.015h.058c.217 0 .362-.165.362-.376 0-.06-.13-5.325 2.594-6.423q.284-.113.522-.136c-.232-.045-.492 0-.782.12"
      clipRule="evenodd"
    ></path>
    <path
      fill="url(#paint3_linear_1334_1871)"
      fillRule="evenodd"
      d="M20 6.133 7.71 10.075s-.521.15-.652.316c-.13.165-.159.631-.159.631L5 26.217l14.26 2.768 1.102-22.867c-.159-.03-.32 0-.363.015"
      clipRule="evenodd"
    ></path>
    <path
      fill="url(#paint4_linear_1334_1871)"
      fillRule="evenodd"
      d="M24.247 8.089s-.015-.12-.087-.166c-.059-.045-.13-.045-.13-.045l-2.015-.15-1.478-1.52a.45.45 0 0 0-.19-.09l-1.1 22.867 7.724-1.73z"
      clipRule="evenodd"
    ></path>
    <path
      fill="url(#paint5_linear_1334_1871)"
      fillRule="evenodd"
      d="M14.928 18.83a5.6 5.6 0 0 0-.74-.812 6 6 0 0 0-.811-.617 5 5 0 0 1-.508-.361c-.144-.12-.26-.24-.347-.346a1.4 1.4 0 0 1-.203-.346 1 1 0 0 1-.058-.361c0-.166.044-.331.102-.467.057-.135.16-.255.26-.36a1.2 1.2 0 0 1 .407-.241c.159-.06.347-.09.55-.106.217-.015.435 0 .637.015.203.015.392.06.58.106.174.045.348.105.493.165s.29.12.391.18l.957-2.948a2.2 2.2 0 0 0-.508-.195 4 4 0 0 0-.666-.136 6.5 6.5 0 0 0-1.652.015c-.652.09-1.232.271-1.754.542a4.5 4.5 0 0 0-1.29.993 4.5 4.5 0 0 0-.825 1.354 5.4 5.4 0 0 0-.334 1.654c-.014.362.014.692.101.993q.11.451.348.858c.145.27.334.511.537.737.202.226.448.436.695.632.203.15.377.3.522.436.144.136.261.27.347.421.087.136.146.271.19.422.043.135.057.285.043.436 0 .15-.044.3-.102.421a.9.9 0 0 1-.246.331c-.101.09-.232.15-.377.18s-.319.046-.508.016a2.4 2.4 0 0 1-.637-.18 4.3 4.3 0 0 1-.594-.287 5 5 0 0 1-.508-.33c-.159-.106-.29-.226-.39-.317l-.653 2.242c.102.15.246.286.406.421q.24.203.565.406c.218.12.45.241.696.346.246.106.522.196.797.271h.058q.892.203 1.695.09a3.4 3.4 0 0 0 1.493-.571 3.36 3.36 0 0 0 1.087-1.294c.276-.557.435-1.234.464-2a3.7 3.7 0 0 0-.174-1.295 3.7 3.7 0 0 0-.536-1.113"
      clipRule="evenodd"
    ></path>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M8.47 23.692a2 2 0 0 1-.093-.123l.653-2.241.028.025c.097.087.218.195.362.29.146.106.32.226.508.331s.391.211.594.286c.203.09.42.15.637.18.19.03.363.016.507-.014a.8.8 0 0 0 .377-.18.9.9 0 0 0 .247-.332 1 1 0 0 0 .102-.421c.014-.15 0-.3-.044-.436a1.6 1.6 0 0 0-.189-.421 1.8 1.8 0 0 0-.326-.402q.105.12.182.251c.087.136.144.27.188.421.043.136.058.286.043.437 0 .15-.043.3-.1.42a.9.9 0 0 1-.247.332.8.8 0 0 1-.377.18c-.145.03-.32.045-.507.015a2.4 2.4 0 0 1-.638-.18 4.4 4.4 0 0 1-.595-.286 5 5 0 0 1-.506-.331 3 3 0 0 1-.363-.29l-.029-.026-.652 2.242q.1.142.239.273m2.136-4.532a4 4 0 0 1-.157-.164 3.8 3.8 0 0 1-.536-.737 3.1 3.1 0 0 1-.347-.858 3.1 3.1 0 0 1-.102-.993 5.4 5.4 0 0 1 .333-1.655q.305-.766.826-1.354a4.5 4.5 0 0 1 1.29-.992 5.4 5.4 0 0 1 1.753-.542c.305-.045.595-.06.87-.06q.414 0 .783.045c.246.03.464.075.667.135.188.045.362.12.507.196l-.022.07a2 2 0 0 0-.34-.115 4 4 0 0 0-.667-.136 6.5 6.5 0 0 0-1.652.015c-.652.09-1.232.271-1.754.542a4.5 4.5 0 0 0-1.29.993 4.5 4.5 0 0 0-.825 1.354 5.4 5.4 0 0 0-.334 1.654c-.015.362.014.693.101.994q.109.45.348.857c.145.27.334.512.536.737zm1.969-2.404q.12.136.294.284c.146.12.32.24.508.361a6 6 0 0 1 1.038.835 6.092 6.092 0 0 0-1.183-.985 5 5 0 0 1-.507-.361 3 3 0 0 1-.15-.134"
      clipRule="evenodd"
      opacity="0.227"
    ></path>
    <path
      fill="url(#paint6_linear_1334_1871)"
      fillRule="evenodd"
      d="m22.507 24.728-.493-17-.087-.09.233 16.849s-2.044 3.22-2.348 3.129c-.45-.135.884-21.242.884-21.242l-.146-.15a.5.5 0 0 0-.187-.09l-1.087 22.55-.015.316.377-.497z"
      clipRule="evenodd"
      opacity="0.41"
    ></path>
    <path
      fill="url(#paint7_linear_1334_1871)"
      fillRule="evenodd"
      d="M16.956 7.111c-.174.707-.391 1.37-.55 1.775-.102.241.013.467.231.497.232.03.493-.136.58-.376.015-.045.405-1.023.652-2.182V6.81z"
      clipRule="evenodd"
    ></path>
    <path
      fill="url(#paint8_linear_1334_1871)"
      fillRule="evenodd"
      d="M10.42 9.217c-.203.451-.405.843-.55 1.113-.13.226-.058.467.16.527.216.075.506-.06.636-.286.015-.03.435-.767.812-1.7z"
      clipRule="evenodd"
    ></path>
    <path
      fill="url(#paint9_linear_1334_1871)"
      fillRule="evenodd"
      d="m19.26 28.985 3.247-4.258L27 27.255z"
      clipRule="evenodd"
      opacity="0.32"
    ></path>
    <path
      fill="url(#paint10_linear_1334_1871)"
      fillRule="evenodd"
      d="m19.26 28.985 3.218-4.258L27 27.255z"
      clipRule="evenodd"
      opacity="0.19"
    ></path>
    <path
      fill="url(#paint11_linear_1334_1871)"
      fillRule="evenodd"
      d="m19.26 28.985 3.218-4.258L27 27.255z"
      clipRule="evenodd"
      opacity="0.19"
    ></path>
    <path
      fill="url(#paint12_linear_1334_1871)"
      fillRule="evenodd"
      d="M16.102 17.07c1.681 2.362 2.812 4.92 3.376 7.402l.885-18.369c-.16-.03-.32 0-.363.015L7.71 10.075s-.115.03-.26.09c3.116 1.113 6.231 3.505 8.652 6.905"
      clipRule="evenodd"
      opacity="0.6"
    ></path>
    <path
      fill="url(#paint13_linear_1334_1871)"
      fillRule="evenodd"
      d="M24.173 7.938c.073.06.073.151.073.151l2.695 19.15-4.435-2.527-.492-17L24 7.864c.014.015.1.015.173.075"
      clipRule="evenodd"
    ></path>
    <path
      fill="url(#paint14_linear_1334_1871)"
      fillRule="evenodd"
      d="M23.855 7.984s.087 0 .16.075c.072.06.086.15.086.15l2.653 18.94.203.121L24.26 8.104s-.014-.09-.073-.15c-.072-.06-.174-.06-.174-.06l-1.985-.15z"
      clipRule="evenodd"
    ></path>
    <path
      fill="url(#paint15_linear_1334_1871)"
      fillRule="evenodd"
      d="m5 26.217 14.26 2.768.697-15.676-13.184.375z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M9.681 10.294c-.13.365-.002.75.287.858.288.109.626-.1.757-.465.13-.366.001-.75-.287-.859s-.627.1-.757.466"
      clipRule="evenodd"
      opacity="0.3"
    ></path>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M9.666 10.12c-.13.366-.001.75.287.859.287.108.627-.1.756-.466.13-.366.002-.75-.287-.858-.288-.109-.626.1-.756.465"
      clipRule="evenodd"
      opacity="0.89"
    ></path>
    <path
      fill="url(#paint16_linear_1334_1871)"
      fillRule="evenodd"
      d="m22.03 7.728-1.48-1.52a.5.5 0 0 0-.187-.09L19.26 28.985l3.26-4.273z"
      clipRule="evenodd"
    ></path>
    <path
      fill="url(#paint17_linear_1334_1871)"
      fillRule="evenodd"
      d="M20 6.133 7.71 10.075s-.521.15-.652.316c-.015.015-.015.03-.029.045l12.39-3.55c.102-.03.349-.12.32.616l-.754 21.453.261.045 1.101-22.867a.65.65 0 0 0-.348 0"
      clipRule="evenodd"
    ></path>
    <path
      fill="url(#paint18_linear_1334_1871)"
      fillRule="evenodd"
      d="M20 6.133 7.71 10.075s-.521.15-.652.316c-.015.015-.015.03-.029.045l2.87-.827 9.869-3.175a.8.8 0 0 1 .362-.015l-1.087 22.536.203.045 1.101-22.867a.65.65 0 0 0-.348 0"
      clipRule="evenodd"
    ></path>
    <path
      fill="url(#paint19_linear_1334_1871)"
      fillRule="evenodd"
      d="m23.16 25.089-.653-.377-3.26 4.273.173-.045s2.87-3.836 3.13-3.957c.19-.075.61.105.61.105"
      clipRule="evenodd"
      opacity="0.32"
    ></path>
    <path
      fill="url(#paint20_linear_1334_1871)"
      fillRule="evenodd"
      d="m19.26 28.985 3.262-4.273c-.015.015-2.072 2.347-3.261 4.273"
      clipRule="evenodd"
      opacity="0.57"
    ></path>
    <path
      fill="url(#paint21_linear_1334_1871)"
      fillRule="evenodd"
      d="m27 27.255-4.478-2.528c-.015 0 .507.09 4.478 2.528"
      clipRule="evenodd"
      opacity="0.46"
    ></path>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M16.307 8.794c-.13.365-.002.75.286.858.289.109.627-.1.756-.465.131-.366.002-.75-.285-.859-.288-.108-.628.1-.757.466"
      clipRule="evenodd"
      opacity="0.3"
    ></path>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M16.292 8.621c-.13.366-.001.75.286.858.288.109.628-.1.757-.465.13-.366.002-.75-.286-.859s-.627.1-.757.466"
      clipRule="evenodd"
      opacity="0.89"
    ></path>
    <path
      fill="#595961"
      fillRule="evenodd"
      d="M10.188 10.857h-.058c-.231-.03-.39-.256-.362-.511.029-.241.854-5.868 4.246-7.146.855-.316 1.58-.256 2.13.21.667.557 1.03 1.67 1.088 3.295.043 1.143-.087 2.136-.087 2.181-.03.241-.247.422-.48.376a.43.43 0 0 1-.361-.496c.13-1.023.275-3.836-.696-4.649-.304-.255-.725-.285-1.29-.075-2.912 1.098-3.68 6.379-3.68 6.424-.059.226-.232.391-.45.391"
      clipRule="evenodd"
    ></path>
    <path
      fill="#B2B2C2"
      fillRule="evenodd"
      d="M15.97 3.44c-.507-.42-1.174-.48-1.97-.195-1.378.526-2.537 1.91-3.334 4.001-.594 1.55-.797 2.95-.797 3.01a.28.28 0 0 0 .058.21c.044.06.102.105.174.105h.044a.27.27 0 0 0 .26-.24c.015-.06.783-5.431 3.783-6.56.608-.225 1.1-.195 1.449.106 1.029.857.884 3.76.754 4.799-.015.15.087.3.231.316.146.015.29-.09.305-.241.015-.166.522-4.077-.957-5.31"
      clipRule="evenodd"
      opacity="0.46"
    ></path>
    <path
      fill="#B2B2C2"
      fillRule="evenodd"
      d="M10.13 10.406h-.028c-.087-.015-.146-.106-.131-.196.015-.06.203-1.429.797-2.979.797-2.06 1.928-3.43 3.275-3.941.769-.286 1.392-.226 1.87.166 1.42 1.188.927 5.04.898 5.205-.014.09-.087.15-.188.135-.086-.015-.145-.09-.145-.195 0-.046.493-3.822-.782-4.905-.377-.286-.9-.316-1.536-.075-3.058 1.158-3.856 6.59-3.856 6.65a.176.176 0 0 1-.174.135"
      clipRule="evenodd"
      opacity="0.81"
    ></path>
    <path
      fill="#595961"
      fillRule="evenodd"
      d="M12.043 6.103c.16-.226.305-.451.449-.692-.057.075-.478.858-1.347.737-.015 0 .492.166.898-.045M11.55 7.066c.13-.241.261-.497.362-.737-.043.09-.333.902-1.246.902 0 0 .508.106.884-.165M11.174 8.059c.116-.256.203-.512.29-.767-.044.09-.203.917-1.16 1.023 0-.015.522.045.87-.256"
      clipRule="evenodd"
      opacity="0.42"
    ></path>
    <path
      fill="#595961"
      fillRule="evenodd"
      d="M16.97 5.125a8 8 0 0 0-.246-.797c.029.09.319.948-.275 1.564 0 0 .434-.3.521-.767M16.406 3.771a10 10 0 0 0-.61-.541c.074.075.755.632.567 1.474-.015 0 .202-.496.043-.933M17.116 6.51a8 8 0 0 0-.102-.828c0 .105.145.993-.551 1.474 0 0 .479-.21.653-.647M17.188 7.924c.015-.271.015-.557 0-.828 0 .106.015.993-.725 1.4 0-.016.507-.166.725-.572"
      clipRule="evenodd"
      opacity="0.62"
    ></path>
    <path
      fill="#595961"
      fillRule="evenodd"
      d="M10.84 9.157c.088-.27.146-.542.204-.797-.03.09-.16.947-1.044 1.158.015 0 .536-.015.84-.361M12.594 5.275q.305-.27.566-.586c-.073.06-.653.677-1.464.451.014 0 .463.27.898.135M13.246 4.584c.233-.15.45-.301.667-.467-.086.046-.753.542-1.521.181 0 0 .405.346.854.286"
      clipRule="evenodd"
      opacity="0.42"
    ></path>
    <path
      fill="#595961"
      fillRule="evenodd"
      d="M14.13 4.087c.262-.075.508-.165.754-.255-.087.03-.87.3-1.507-.271 0 0 .305.451.754.526M14.869 3.817c.204.03.406.045.61.06-.073-.015-.696-.06-.972-.662.015 0 .087.406.362.602M15.653 4.147c.13.166.26.331.39.482-.043-.06-.449-.557-.246-1.174.015 0-.203.346-.145.692"
      clipRule="evenodd"
      opacity="0.62"
    ></path>
    <path
      fill="url(#paint22_linear_1334_1871)"
      fillRule="evenodd"
      d="M16.652 8.585c.014-.165.507-3.971-.87-5.13a1.38 1.38 0 0 0-.927-.33c-.261 0-.551.06-.856.18-1.333.496-2.449 1.835-3.231 3.881-.594 1.535-.782 2.904-.797 2.964 0 .045.028.09.072.09h.015c.043 0 .072-.03.072-.075.015-.06.797-5.551 3.913-6.725.666-.255 1.232-.21 1.638.136 1.318 1.098.826 4.934.812 4.98 0 .044.028.09.072.09h.014c.043.015.073-.015.073-.06"
      clipRule="evenodd"
    ></path>
    <path
      fill="url(#paint23_linear_1334_1871)"
      fillRule="evenodd"
      d="M17.232 6.705q-.087-2.437-1.087-3.295a1.78 1.78 0 0 0-1.29-.406c.377.03.724.166 1.015.406.667.557 1.029 1.67 1.086 3.295.044 1.143-.086 2.136-.086 2.181a.44.44 0 0 1-.29.361c.03.015.043.015.073.015a.43.43 0 0 0 .477-.376c.015-.045.146-1.023.102-2.181"
      clipRule="evenodd"
    ></path>
    <path
      fill="url(#paint24_linear_1334_1871)"
      fillRule="evenodd"
      d="M14.03 4.042c-2.913 1.098-3.682 6.379-3.682 6.439a.44.44 0 0 1-.29.36c.03.016.044.016.073.016h.058c.218 0 .39-.165.42-.376.014-.06.768-5.326 3.68-6.424a2.1 2.1 0 0 1 .538-.135c-.218-.03-.494.015-.797.12"
      clipRule="evenodd"
    ></path>
    <defs>
      <linearGradient
        id="paint0_linear_1334_1871"
        x1="13.611"
        x2="13.156"
        y1="3.941"
        y2="10.129"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0.65"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0.01"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_1334_1871"
        x1="16.932"
        x2="20.132"
        y1="7.483"
        y2="10.286"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01"></stop>
        <stop offset="1" stopOpacity="0.4"></stop>
      </linearGradient>
      <linearGradient
        id="paint2_linear_1334_1871"
        x1="15.649"
        x2="19.036"
        y1="10.725"
        y2="7.57"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01"></stop>
        <stop offset="1" stopOpacity="0.4"></stop>
      </linearGradient>
      <linearGradient
        id="paint3_linear_1334_1871"
        x1="11.338"
        x2="-1.818"
        y1="1.518"
        y2="16.677"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B8D26E"></stop>
        <stop offset="1" stopColor="#7FB525"></stop>
      </linearGradient>
      <linearGradient
        id="paint4_linear_1334_1871"
        x1="29.335"
        x2="22.114"
        y1="5.313"
        y2="5.447"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B4E034"></stop>
        <stop offset="1" stopColor="#60A927"></stop>
      </linearGradient>
      <linearGradient
        id="paint5_linear_1334_1871"
        x1="7.859"
        x2="1.939"
        y1="15.421"
        y2="29.836"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff"></stop>
        <stop offset="1" stopColor="#CECEEB"></stop>
      </linearGradient>
      <linearGradient
        id="paint6_linear_1334_1871"
        x1="16.346"
        x2="25.721"
        y1="50.922"
        y2="50.903"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D1D1B" stopOpacity="0.5"></stop>
        <stop offset="0.038" stopColor="#1D1D1B" stopOpacity="0.484"></stop>
        <stop offset="0.424" stopColor="#1D1D1B" stopOpacity="0.319"></stop>
        <stop offset="1" stopColor="#1D1D1B" stopOpacity="0.01"></stop>
      </linearGradient>
      <linearGradient
        id="paint7_linear_1334_1871"
        x1="17.434"
        x2="15.879"
        y1="5.801"
        y2="6.638"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01"></stop>
        <stop offset="1" stopOpacity="0.4"></stop>
      </linearGradient>
      <linearGradient
        id="paint8_linear_1334_1871"
        x1="10.914"
        x2="9.82"
        y1="8.283"
        y2="9.223"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01"></stop>
        <stop offset="1" stopOpacity="0.4"></stop>
      </linearGradient>
      <linearGradient
        id="paint9_linear_1334_1871"
        x1="21.579"
        x2="21.69"
        y1="27.266"
        y2="28.725"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01"></stop>
        <stop offset="1" stopOpacity="0.4"></stop>
      </linearGradient>
      <linearGradient
        id="paint10_linear_1334_1871"
        x1="18.995"
        x2="19.251"
        y1="25.13"
        y2="28.924"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0.5"></stop>
        <stop offset="0.09" stopColor="#fff" stopOpacity="0.455"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0.01"></stop>
      </linearGradient>
      <linearGradient
        id="paint11_linear_1334_1871"
        x1="18.501"
        x2="18.958"
        y1="25.72"
        y2="29.772"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01"></stop>
        <stop offset="1" stopOpacity="0.4"></stop>
      </linearGradient>
      <linearGradient
        id="paint12_linear_1334_1871"
        x1="16.71"
        x2="5.002"
        y1="2.404"
        y2="9.175"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0.5"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0.01"></stop>
      </linearGradient>
      <linearGradient
        id="paint13_linear_1334_1871"
        x1="18.968"
        x2="29.302"
        y1="37.794"
        y2="37.814"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D1D1B" stopOpacity="0.5"></stop>
        <stop offset="0.09" stopColor="#1D1D1B" stopOpacity="0.455"></stop>
        <stop offset="1" stopColor="#1D1D1B" stopOpacity="0.01"></stop>
      </linearGradient>
      <linearGradient
        id="paint14_linear_1334_1871"
        x1="26.369"
        x2="24.901"
        y1="7.173"
        y2="7.533"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0.4"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0.01"></stop>
      </linearGradient>
      <linearGradient
        id="paint15_linear_1334_1871"
        x1="13.198"
        x2="13.962"
        y1="29.152"
        y2="25.472"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D1D1B" stopOpacity="0.5"></stop>
        <stop offset="0.09" stopColor="#1D1D1B" stopOpacity="0.455"></stop>
        <stop offset="1" stopColor="#1D1D1B" stopOpacity="0.01"></stop>
      </linearGradient>
      <linearGradient
        id="paint16_linear_1334_1871"
        x1="17.612"
        x2="27.021"
        y1="50.453"
        y2="50.461"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D1D1B" stopOpacity="0.5"></stop>
        <stop offset="1" stopColor="#1D1D1B" stopOpacity="0.01"></stop>
      </linearGradient>
      <linearGradient
        id="paint17_linear_1334_1871"
        x1="9.013"
        x2="4.45"
        y1="4.808"
        y2="22.34"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0.5"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0.01"></stop>
      </linearGradient>
      <linearGradient
        id="paint18_linear_1334_1871"
        x1="9.013"
        x2="4.45"
        y1="4.808"
        y2="22.34"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0.5"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0.01"></stop>
      </linearGradient>
      <linearGradient
        id="paint19_linear_1334_1871"
        x1="20.089"
        x2="16.482"
        y1="23.186"
        y2="28.151"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0.5"></stop>
        <stop offset="0.09" stopColor="#fff" stopOpacity="0.455"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0.01"></stop>
      </linearGradient>
      <linearGradient
        id="paint20_linear_1334_1871"
        x1="21.177"
        x2="20.82"
        y1="24.328"
        y2="25.128"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01"></stop>
        <stop offset="1" stopOpacity="0.4"></stop>
      </linearGradient>
      <linearGradient
        id="paint21_linear_1334_1871"
        x1="24.718"
        x2="24.701"
        y1="25.386"
        y2="25.601"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01"></stop>
        <stop offset="1" stopOpacity="0.4"></stop>
      </linearGradient>
      <linearGradient
        id="paint22_linear_1334_1871"
        x1="11.729"
        x2="10.17"
        y1="2.618"
        y2="8.778"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0.65"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0.01"></stop>
      </linearGradient>
      <linearGradient
        id="paint23_linear_1334_1871"
        x1="15.219"
        x2="17.932"
        y1="6.172"
        y2="8.929"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01"></stop>
        <stop offset="1" stopOpacity="0.4"></stop>
      </linearGradient>
      <linearGradient
        id="paint24_linear_1334_1871"
        x1="13.486"
        x2="17.233"
        y1="10.232"
        y2="6.384"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.01"></stop>
        <stop offset="1" stopOpacity="0.4"></stop>
      </linearGradient>
    </defs>
  </svg>
);

export { ShopifyIcon };
